class AdditionalProducts extends HTMLElement {
  connectedCallback() {
    try {
      const root = this;
      const items = Array.from(root.querySelectorAll('.additional-products__item'));
      if (!items.length) return;

      const moneyFormatStr = root.dataset.moneyFormat || "$0.00";
      const formatMoney = (cents) => {
        try {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(Math.round(cents), moneyFormatStr);
          }
        } catch (e) { 
          console.error('Error in Shopify.formatMoney', e);
         }
        return `$${(Math.round(cents) / 100).toFixed(2)}`;
      };

      const totalEl = root.querySelector('[data-ap-total]');
      const countEl = root.querySelector('[data-ap-count]');
      const pluralEl = root.querySelector('.ap-plural');

      const updateItemPrice = (li) => {
        try {
          const priceNow = li.querySelector('[data-ap-price]');
          const priceWas = li.querySelector('.ap-price__was');
          const variantSel = li.querySelector('.ap-item__variant');
          if (!variantSel || !priceNow) return;
          
          let opt = null;
          if (variantSel.tagName === 'SELECT') {
            if (variantSel.options && variantSel.options.length > 0) {
              opt = variantSel.selectedOptions[0];
            }
          } else {
            opt = variantSel;
          }
          
          if (!opt) return;
          
          const dollars = parseFloat(opt?.dataset?.price || '0');
          const cents = Math.round(dollars * 100);
          priceNow.textContent = formatMoney(cents);
          const comparePrice = parseFloat(opt?.dataset?.variantCompareAtPrice || '0');
          if (priceWas && comparePrice > dollars) {
            const compareCents = Math.round(comparePrice * 100);
            priceWas.textContent = formatMoney(compareCents);
            priceWas.style.display = 'inline';
          } else if (priceWas) {
            priceWas.style.display = 'none';
          }
        } catch (e) { 
          console.error('Error updating item price', e);
        }
      };

      const getItemPrice = (li) => {
        const variantSel = li.querySelector('.ap-item__variant');
        let qty = 1;
        let price = 0;
        if (variantSel) {
          let opt = null;
          if (variantSel.tagName === 'SELECT') {
            if (variantSel.options && variantSel.options.length > 0) {
              opt = variantSel.selectedOptions[0];
            }
          } else {
            opt = variantSel;
          }
          
          if (opt) {
            price = parseFloat(opt?.dataset?.price || '0') * 100;
          }
        }
        return price * qty;
      };

      const recalc = () => {
        let sum = 0;
        let count = 0;
        items.forEach((li) => {
          const checked = li.querySelector('.ap-item__check')?.checked;
          if (checked) {
            sum += getItemPrice(li);
            count++;
          }
        });
        
        if (totalEl) totalEl.textContent = formatMoney(sum);
        if (countEl) countEl.textContent = count;

        if (pluralEl) {
          pluralEl.style.display = count === 1 ? 'none' : 'inline';
        }
      };

      root.addEventListener('change', (e) => {
        if (e.target.matches('.ap-item__check,.ap-item__variant')) {
          if (e.target.matches('.ap-item__variant')) {
            const li = e.target.closest('.additional-products__item');
            if (li) updateItemPrice(li);
          }
          recalc();
        }
      });

      items.forEach(updateItemPrice);
      recalc();

      const cta = root.querySelector('[data-ap-add]');
      if (cta) {
        let submitting = false;
        cta.addEventListener('click', async (e) => {
          if (e) e.preventDefault();
          if (submitting) return;
          submitting = true;

          const originalHtml = cta.innerHTML;
          cta.setAttribute('disabled', 'disabled');
          cta.setAttribute('aria-busy', 'true');
          cta.classList.add('is-loading');
          cta.innerHTML = '<span class="ap-spinner" style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.6);border-top-color:#fff;border-radius:50%;margin-right:8px;vertical-align:middle;animation:apspin 1s linear infinite"></span><span>Adding…</span>';

          if (!document.getElementById('apspinner-style')) {
            const style = document.createElement('style');
            style.id = 'apspinner-style';
            style.textContent = '@keyframes apspin{to{transform:rotate(360deg)}}';
            document.head.appendChild(style);
          }

          const payload = { items: [] };
          items.forEach((li) => {
            const checked = li.querySelector('.ap-item__check')?.checked;
            if (!checked) return;
            const variantEl = li.querySelector('.ap-item__variant');
            if (!variantEl) return;
            
            let id = null;
            let opt = null;
            
            if (variantEl.tagName === 'SELECT') {
              if (variantEl.options && variantEl.options.length > 0) {
                id = variantEl.value;
                opt = variantEl.selectedOptions[0];
              }
            } else {
              id = variantEl.value;
              opt = variantEl;
            }
            
            if (!id || !opt) return;
            
            const quantity = 1;
            const sellingPlanId = opt?.dataset?.sellingPlanId;
            if (id) {
              const item = { id: Number(id), quantity };
              if (sellingPlanId) item.selling_plan = sellingPlanId;
              payload.items.push(item);
            }
          });
          if (payload.items.length === 0) return;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            });
            if (!res.ok) throw new Error('Add to cart failed');
            
            // Prestige (new theme): refreshing the cart is handled by the "cart:refresh"
            // listeners (cart count, cart dot and cart drawer contents all subscribe on document).
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            // Then open the cart drawer the same way the header cart button does.
            setTimeout(() => {
              const opener = document.querySelector('[aria-controls="cart-drawer"]');
              const drawer = document.getElementById('cart-drawer');
              if (opener) {
                opener.click();
              } else if (drawer && typeof drawer.show === 'function') {
                drawer.show();
              }
            }, 300);
            
          } catch (err) { console.error(err); }
          finally {
            cta.innerHTML = originalHtml;
            cta.removeAttribute('disabled');
            cta.removeAttribute('aria-busy');
            cta.classList.remove('is-loading');
            submitting = false;
          }
        });
      }
    } catch (e) {
      console.error('AdditionalProducts init error', e);
    }
  }
}

customElements.define('additional-products', AdditionalProducts);
